export const PREBUDGETSTATUS = {
  canceled: Number(process.env.REACT_APP_PREBUDGET_CANCELED),
  pending: Number(process.env.REACT_APP_PREBUDGET_PENDING),
  processing: Number(process.env.REACT_APP_PREBUDGET_PROCESSING),
};
